import { DashboardLayoutType, LayoutConfigType } from "api/model/dashboard/DashboardComponent";

export const defaultDashboardLayouts: Record<
  DashboardLayoutType,
  { defaultLayoutConfig: LayoutConfigType[DashboardLayoutType] }
> = {
  [DashboardLayoutType.VERTICAL]: {
    defaultLayoutConfig: {
      width: 6,
      height: "max-content",
    },
  },
  [DashboardLayoutType.HORIZONTAL_FLEX]: {
    defaultLayoutConfig: {
      width: 6,
      height: "max-content",
    },
  }
};

export const getDefaultLayout = (
  layoutType: DashboardLayoutType = DashboardLayoutType.HORIZONTAL_FLEX
): LayoutConfigType => {
  const defaultLayout = defaultDashboardLayouts[layoutType]?.defaultLayoutConfig;
  return Object.freeze({ [layoutType]: defaultLayout });
};

